module.exports = "<footer class=\"haveFooter\">\n  <app-user-opinion></app-user-opinion>\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// /srv/projects/jsapp/src/app/core/footer/footer.component.html
// module id = cvDN
// module chunks = 6